import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getNewsItem } from '../lib/api';
import { formatDate } from '../lib/utils';
import { Card, CardContent } from '../components/ui/card';
import { ArrowLeft, Calendar } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const NewsDetailPage = () => {
  const { newsId } = useParams();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getNewsItem(newsId);
        setNews(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetch();
  }, [newsId]);

  const getPhotoUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    return `${API}/api/files/${path}`;
  };

  if (loading) {
    return (
      <div className="min-h-screen pt-24 pb-16 px-4">
        <div className="container-max animate-pulse">
          <div className="h-8 bg-white/10 rounded w-1/4 mb-8" />
          <div className="h-12 bg-white/10 rounded w-1/2 mb-4" />
          <div className="h-4 bg-white/10 rounded w-3/4" />
        </div>
      </div>
    );
  }

  if (!news) {
    return (
      <div className="min-h-screen pt-24 pb-16 px-4">
        <div className="container-max text-center">
          <h1 className="text-2xl font-heading font-bold mb-4">News nicht gefunden</h1>
          <Link to="/" className="text-primary hover:underline">Zur Startseite</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="news-detail-page">
      <section className="section-padding">
        <div className="container-max max-w-3xl">
          <Link to="/" className="inline-flex items-center gap-2 text-text-secondary hover:text-white mb-6">
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </Link>

          <div className="flex items-center gap-2 text-accent text-sm mb-4">
            <Calendar className="w-4 h-4" />
            <span>{formatDate(news.created_at)}</span>
          </div>

          <h1 className="text-3xl md:text-4xl font-heading font-bold uppercase tracking-tighter mb-6">
            {news.title}
          </h1>

          {news.image_url && (
            <img
              src={getPhotoUrl(news.image_url)}
              alt={news.title}
              className="w-full rounded-lg mb-8 max-h-[400px] object-cover"
            />
          )}

          <Card className="card-surface">
            <CardContent className="p-6 md:p-8">
              <div className="prose prose-invert max-w-none whitespace-pre-line text-text-secondary leading-relaxed">
                {news.content}
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default NewsDetailPage;
